import {defineAbilityConfig} from '../system/defineAbilityConfig';

export const canViewWxpTour = defineAbilityConfig([
  {
    userTypes: {
      authorizedInDesigner: true,
    },
    siteModes: {design: true, edit: true},
    workflows: {canvas: true, comment: true},
  },
] as const);
